<template>
    <div>
        <div class="content">
            <div class="title-box">
                <h3 class="pull-left">{{detailLan.detailText}}&nbsp;&nbsp;({{queryObj.MODIFIED_ID}})</h3>
                <div class="pull-right" style="margin-top:12px;">
                    <el-button class="preview-btn" type="warning" round  @click="$router.go(-1)">
                        {{detailLan.goback}}
                    </el-button>
                </div>
                <div class="clear"></div>
            </div>
            <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
                <mtable v-if="trData"
                :thData="thData"
                :trData="trData"
                :page="page"
                :selPage="selPage"
                :tip="tip"
                :multiLanguage="detailLan"
                :jsonExcelAjax="jsonExcelAjax"
                :downLoadTran="downLoadTran"
                :name="name"
                @tableChange="tableAjax">
                </mtable>
            </div>
        </div>
    </div>
</template>
<script>
import mtable from "../../comm/mytable"
import {getTimeDiff, formatDate, updateTimeByUtc} from 'common/js/util'
import {URL_AUDITREPORTDETAIL} from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
    name:'auditTrailDetailReport',
    mixins: [
      require("common/mixin/base.js").base({detailLan: "auditTrailReport"})
    ],
    props: ['curArea'],
    data(){
        return {
            trData:[],
            queryObj: {},
            url: '',
            loading: true,
            changeTime: false,
            timeDiff: 0,
            page: {
                active: 1,
                pageLeng: 0
            },
            selPage: {
                list: [5, 10, 25, 50],
                active: localStorage.pageMaxIndex,
                limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
            },
            tip: {
                key: ['OLD_VALUE','NEW_VALUE']
            }
        }
    },
    computed: {
        thData(){
            return this.detailLan.detailTh
        },
        name(){
            return this.detailLan.detailText
        },
        downLoadTran(){
            return { TYPE: this.detailLan.typeList}
        },
        jsonExcelAjax () {
            return {
                url: this.url,
                ajaxType: "get",
                getKey: ["data", "data",'rows'],
                ajaxPar: {
                    lang: this.LANGUAGE,
                    begintime: formatDate(this.queryObj.begintime),
                    endtime: formatDate(this.queryObj.endtime),
                    pageNum: 0,
                    pageSize: this.page.pageLeng,
                    id: this.queryObj.MODIFIED_ID
                }
            }
        }
    },
    mounted() {
        this.queryObj = this.$route.query
        this.timeDiff = getTimeDiff()
        //this.queryObj.begintime = new Date(new Date(this.queryObj.begintime).getTime())
        //this.queryObj.endtime = new Date(new Date(this.queryObj.endtime).getTime())
        this.tableAjax()
    },
    methods: {
        tableAjax(){
            this.changeTime = true
            this.url = api.getUrl20(this.curArea, URL_AUDITREPORTDETAIL)
            let tableObj = {
                params: {
                    begintime: formatDate(this.queryObj.begintime),
                    endtime: formatDate(this.queryObj.endtime),
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit,
                    id: this.queryObj.MODIFIED_ID
                }
            }
            this.$http.get(this.url, tableObj).then((res) => {
                this.trData = res.data.data.rows
                this.page.pageLeng = res.data.data.count
                this.setOfficeState()
                this.loading = false
            })
        },
        setOfficeState(){
            let list = this.detailLan.typeList
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach((item,index) =>{
                    let temp = this.trData[index]
                    temp.type = (temp.TYPE || temp.TYPE == 0) ? list[temp.TYPE] : ''
                    if(this.changeTime) {
                        temp.LOG_DATE = temp.LOG_DATE ? updateTimeByUtc(this.timeDiff,temp.LOG_DATE) : ''
                    }
                }) 
            }
        }
    },
    watch: {
        detailLan(){
            this.changeTime = false
            this.setOfficeState()
        },
        curArea(){
            sessionStorage.removeItem('back')
            this.$router.push('auditTrailReport')
        }
    },
    components: {
        mtable
    }
}
</script>
<style lang="scss" scoped>
    .title-box{
        border: 1px solid #3F51B5;
        background: #3F51B5;
        padding: 0 20px;
        color: #fff;
        border-radius: 5px 5px 0 0;
        .preview-btn{
            border: 1px solid #F08712;
            background-color: #F08712;
            border-radius: 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// auditTrailDetailReport.vue?5fdbdec4